// Auto-generated by generate-version.js — do not edit manually.
// Source of truth is DynamoDB ${environment}-Configs PK=GLOBEIQ_VERSION SK=META.
export const appVersion = {
  version: 'v26.07.23',
  deploy: '-dev.51',
};
